<div [style.transform]="'translate3d(' + (progress - 100) + '%, 0px, 0px)'" class="pace" [class.transition]="transition"
     [attr.loading-bar-active]="loading"
     [class.pace-inactive]="!show">
  <ng-content></ng-content>
</div>
